import { PaginationOptionsDto } from '../../pagination-options-types';

export class GetInvalidReferralDepthsDto extends PaginationOptionsDto {}

export class InvalidReferralDepthRowDto {
  childId: string;
  childAlias: string;
  childEmail: string;
  childDepth: number;

  parentId: string;
  parentAlias: string;
  parentEmail: string;
  parentDepth: number;

  diff: number;
}

export class InvalidReferralDepthsResponseDto {
  items: InvalidReferralDepthRowDto[];
  totalCount: number;
}

export class FixReferralDepthsResponseDto {
  updatedUsersCount: number;
}
